// Constants
import {REDUX_SET, REDUX_RESET} from './constants';

export const set = (data) => ({type: REDUX_SET, data});

export const reset = () => ({type: REDUX_RESET});
